import { jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
class ErrorBoundaryClassComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error("Error boundary caught an error", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
const ErrorBoundaryFunctionalComponent = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    const resetError = () => setHasError(false);
    window.addEventListener("resetErrorBoundary", resetError);
    return () => {
      window.removeEventListener("resetErrorBoundary", resetError);
    };
  }, []);
  return hasError ? null : /* @__PURE__ */ jsx(ErrorBoundaryClassComponent, { children });
};
var ErrorBoundary_default = ErrorBoundaryFunctionalComponent;
export {
  ErrorBoundary_default as default
};
